import {Component, OnInit, Input, PLATFORM_ID, Inject, ViewChild, Output, EventEmitter} from '@angular/core';
import {CropperSettings, ImageCropperComponent} from "ngx-img-cropper";
import {isPlatformBrowser} from "@angular/common";
import { Event } from "../event";

@Component({
  selector: 'app-crop-modal',
  templateUrl: './crop-modal.component.html',
  styleUrls: ['./crop-modal.component.css']
})

export class CropModalComponent implements OnInit {

  @Input() cropsettings:CropperSettings;
  @Input() event:Event;
  @Input() name:any;
  @Input() index:any;

  @Output() croppedEnd = new EventEmitter();
  firstvalidate : any = false;
  tmp:any;
  Imgdata:any = {};

  settingcrop:CropperSettings = new CropperSettings();
  @ViewChild('cropper', {})
  cropper: ImageCropperComponent;
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {


  }

  ngOnInit() {
    this.settingcrop = this.cropsettings;
  }


  setCrop(file) {
    this.tmp = file;
    this.cropper.setImage(file);
  }

  showModal(){
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.Imgdata = {};
        let $ = window['jQuery'];
          $('#'+this.name).modal('show');
      } catch (e) {
        console.log("not in browser");
      }
    }

  }


  ok() {
    if (isPlatformBrowser(this.platformId)) {
      try {
       // console.log(this.Imgdata.image);
        let $ = window['jQuery'];
        this.firstvalidate = true;
        $('#'+this.name).modal('hide');
        this.croppedEnd.emit(true);
      } catch (e) {
        console.log("not in browser");
      }
    }
  }

  closeModal() {
    if (isPlatformBrowser(this.platformId)) {
      try {
        let $ = window['jQuery'];
        $('#'+this.name).modal('hide');
        if(!this.firstvalidate) {
          this.Imgdata.image=0;
          /*this.cropper.setImage(null);*/
        }
      } catch (e) {
        console.log("not in browser");
      }
    }
  }

}
